// src/services/QuestionService.ts

import { Question } from "../models/Question";
import { Answer } from "../models/Answer";
import { Event } from "../models/Event";
import api from "./api";
import { clean } from "../utils/utils";

const PATH = "/api/v1/matter-type-questions";

export const MatterTypeQuestionService = {
  async getQuestion(
    matterId: string,
    questionId: string,
  ): Promise<Question | null> {
    try {
      const res = await api.get<Question>(`${PATH}/${questionId}`, {
        params: { matterId },
      });
      return res.data;
    } catch (err: any) {
      if (err.response?.status === 404) return null;
      throw err;
    }
  },

  async getAllQuestions(matterId: string): Promise<Question[]> {
    const res = await api.get<Question[]>(PATH, {
      params: { matterId },
    });
    return res.data;
  },

  async createAnswer(
    matterId: string,
    questionId: string,
    answerData: Omit<Answer, "_id" | "createdAt" | "updatedAt">,
  ): Promise<string> {
    const res = await api.post(`${PATH}/${questionId}/answers`, {
      ...clean(answerData),
      matterId,
    });
    return res.data.data._id;
  },

  async updateQuestion(
    matterId: string,
    questionId: string,
    updatedData: Partial<Omit<Question, "_id" | "createdAt">>,
  ): Promise<void> {
    await api.put(`${PATH}/${questionId}`, {
      ...clean(updatedData),
      matterId,
    });
  },

  async deleteQuestion(matterId: string, questionId: string): Promise<void> {
    await api.delete(`${PATH}/${questionId}`, {
      params: { matterId },
    });
  },

  async getQuestionEvents(
    matterId: string,
    questionId: string,
  ): Promise<Event[]> {
    const res = await api.get<Event[]>(`${PATH}/${questionId}/events`, {
      params: { matterId },
    });
    return res.data ?? [];
  },
};
